import { signedIntToHex } from '@work4all/utils/lib/colorConversion';

export type IColorCellProps = {
  value: string;
};

export const ColorCell = (props: IColorCellProps) => {
  const { value } = props;

  let hexValue = '000000';
  if (value.includes(',')) {
    hexValue = value.split(',')[0];
  } else {
    hexValue = signedIntToHex(value);
  }
  return (
    <input
      type="color"
      value={hexValue}
      readOnly
      disabled
      style={{
        border: 'none',
        cursor: 'default',
        width: '100%',
      }}
    />
  );
};
